import React, { useState } from "react";
import { useSearchParams , useNavigate } from "react-router-dom";
import { Box, TextField, Button, Typography, Alert, Paper } from "@mui/material";
import { useAuth } from "../context/AuthContext";

const ResetPasswordForm = () => {
  const navigate = useNavigate();
  const { resetPass } = useAuth();
  const [newPassword, setNewPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [searchParams] = useSearchParams();

  const token = searchParams.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (newPassword !== repeatPassword) {
      setError("Las contraseñas no coinciden");
      return;
    }
    try {
      await resetPass(token, newPassword);
      setSuccess("Contraseña restablecida correctamente");
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError(err.message);
    }
  };

  const isDisabled = !newPassword || !repeatPassword || newPassword !== repeatPassword;

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#FBF7EF",
        p: 2,
      }}
    >
      <Paper elevation={3} sx={{ p: 4, borderRadius: 3, maxWidth: 400, width: "100%" }}>
        <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, textAlign: "center" }}>
          Restablecer contraseña
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

        <form onSubmit={handleSubmit}>
          <TextField
            label="Nueva contraseña"
            type="password"
            fullWidth
            margin="normal"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <TextField
            label="Repetir contraseña"
            type="password"
            fullWidth
            margin="normal"
            value={repeatPassword}
            onChange={(e) => setRepeatPassword(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={isDisabled}
            sx={{ mt: 2, backgroundColor: "#003B23", "&:hover": { backgroundColor: "#3b7b61" } }}
          >
            Restablecer
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default ResetPasswordForm;
